export const industryOptions = [
  { value: "medical_clinic", label: "hmedical_clinic" },
  { value: "dental", label: "hdental" },
  { value: "physiotherapy", label: "hphysiotherapy" },
  { value: "chiropractic", label: "hchiropractic" },
  { value: "massage_therapy", label: "hmassage_therapy" },
  { value: "podiatry", label: "hpodiatry" },
  { value: "psychology", label: "hpsychology" },
  { value: "veterinary", label: "hveterinary" },
  { value: "aesthetic_care", label: "haesthetic_care" },
  { value: "vision_care", label: "hvision_care" },
  { value: "medical_equipment", label: "hmedical_equipment" },
  { value: "other", label: "hother" },
];
